<div class="flex flex-col gap-3 mt-3">
  <app-message-notif />
  <app-banner-upgrade />

  <div class="flex items-center gap-3">
    <h2 class="text-2xl font-semibold mb-0">Dashboard</h2>
    <button nz-button class="flex items-center gap-1 px-3 py-1 border-2 !border-[#FFB088] rounded-lg bg-[#FFE8D9]" (click)="handleGuide()">
      <img src="https://storage.googleapis.com/komerce/rajaongkir/question-bg-orange.png" alt="guide" width="16">
      <span class="text-primary font-medium">Guide (ID)</span>
    </button>
  </div>

  <!-- Header Cards Row -->
  <div class="flex flex-col lg:flex-row gap-3">
    <!-- Balance Card -->
    <div class="w-full">
      <app-withdrawl-card />
    </div>

    <!-- Potential Income Card -->
    <div *ngIf="packageStatus === 3" class="w-full">
      <div class="card shadow-sm border-0 h-full">
        <nz-skeleton [nzLoading]="loading" [nzActive]="true">
          <div class="p-4 flex-grow">
            <div class="flex items-center gap-1 mb-2">
              <span class="card-title mb-0">Potential Income</span>
              <i class="icon-info-circle"
                placement="top right"
                ngbPopover="Potential Income is the balance you will receive when the order status has changed from sent to received."
                triggers="mouseenter:mouseleave"></i>
            </div>
            <h2 class="nominal mb-0 truncate">
              {{ possibleIncome.possible_income | currency : "IDR" : "symbol" : "1.0-0" }}
            </h2>
          </div>
          <div class="footer-card-text p-4">
            Of this value, <b class="text-primary">Rp 0,-</b> needs to be monitored
          </div>
        </nz-skeleton>
      </div>
    </div>

    <!-- Commission Card -->
    <div *ngIf="packageStatus === 3" class="w-full">
      <div class="card shadow-sm border-0 h-full flex flex-col">
        <nz-skeleton [nzLoading]="loading" [nzActive]="true" class="h-full flex flex-col">
          <div class="p-4 flex-grow">
            <div class="flex items-center gap-1 mb-2">
              <span class="card-title mb-0">Commission</span>
              <i class="icon-info-circle"
                placement="top right"
                ngbPopover="Commission is calculated at 1% of total shipping costs"
                triggers="mouseenter:mouseleave"></i>
            </div>
            <h2 class="nominal mb-0 truncate">
              {{ balance.commission | currency : "IDR" : "symbol" : "1.0-0" }}
            </h2>
          </div>

          <div class="bg-footer-card p-2 flex items-center justify-around gap-2 mt-auto">
            <button class="btn-link text-white no-underline flex flex-col md:flex-row items-center gap-1 md:gap-2 p-2 focus:outline-none"
              [disabled]="isSandBoxMode"
              (click)="handleWithdrawalCommission()">
              <i class="icon icon-receive-square"></i>
              <span class="text-card-button hidden sm:block">Withdrawal</span>
            </button>

            <a [routerLink]="['/finance/commission/detail']"
              class="text-white no-underline flex flex-col md:flex-row items-center gap-1 md:gap-2 p-2">
              <i class="icon icon-document-text"></i>
              <span class="text-card-button hidden sm:block">Detail</span>
            </a>
          </div>
        </nz-skeleton>
      </div>
    </div>
  </div>

  <!-- Shipping Performance Section -->
  <div *ngIf="packageStatus === 3" class="card shadow-sm border-0 p-4">
    <nz-skeleton [nzLoading]="loading" [nzActive]="true">
      <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 mb-4">
        <h4 class="text-xl font-semibold mb-0">Shipping Performance</h4>

        <div class="border rounded px-2 py-1 flex items-center w-full md:w-auto bg-white" style="max-width: 300px;">
          <input
            type="text"
            class="w-full border-0 bg-transparent date-pick text-center focus:outline-none"
            ngxDaterangepickerMd
            [(ngModel)]="selected"
            [ngModelOptions]="{ standalone: true }"
            [showCustomRangeLabel]="true"
            [keepCalendarOpeningWithRange]="true"
            [alwaysShowCalendars]="true"
            [ranges]="ranges"
            [linkedCalendars]="true"
            [isInvalidDate]="isInvalidDate"
            [showCancel]="true"
            [showRangeLabelOnInput]="true"
            opens="left"
            drops="down"
            [locale]="setlocale"
            (change)="onChangeDate($event)"
            #datePickerInput
          />
          <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/calendar.svg" alt="calendar" class="ml-2" width="18" />
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        <div *ngFor="let card of cards">
          <app-stat-card [card]="card" class="h-full"></app-stat-card>
        </div>
      </div>

      <div class="grid grid-cols-1 xl:grid-cols-3 gap-3 mt-4">
        <div class="xl:col-span-2">
          <app-chart-analytics></app-chart-analytics>
        </div>
        <div class="xl:col-span-1">
          <app-api-usage></app-api-usage>
        </div>
      </div>
    </nz-skeleton>
  </div>

  <!-- bottom Sections -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
    <div class="w-full">
      <app-payment-service></app-payment-service>
    </div>
    <div class="w-full">
      <app-qrisly-stat></app-qrisly-stat>
    </div>
  </div>
</div>

<app-modal-start-tour [isVisibleBanner]="startTour" (isVisibleBannerChange)="handleStartTour($event)"/>
